import { useFirestore, useFirestoreCollection } from 'reactfire';
 
import {
  collection,
  CollectionReference,
  limit,
  orderBy,
  startAfter,
  query,
  where,
  DocumentSnapshot
} from 'firebase/firestore';

import { User } from '../firebase/entities';

type WithId<T> = T & { id: string };
 
const useFetchUsers = (
  search: string,
  params: {
    cursor: DocumentSnapshot | undefined;
    itemsPerPage: number;
  }
) => {
  const firestore = useFirestore();
  const userCollection = 'users';
  
  const createConstraints = (orderByField: string) => {
    const constraints: any[] = [orderBy(orderByField, 'desc'), limit(params.itemsPerPage)];
    
    if (params.cursor) {
      constraints.push(startAfter(params.cursor));
    }

    return constraints;
  };

  const collectionRef = collection(firestore, userCollection) as CollectionReference<WithId<User>>;

  const nameQuery = search ? query(
    collectionRef,
    where('name', '>=', search),
    where('name', '<=', `${search}\uf8ff`),
    ...createConstraints('name')
  ) : query(collectionRef, ...createConstraints('name'));

  const emailQuery = search ? query(
    collectionRef,
    where('email', '>=', search),
    where('email', '<=', `${search}\uf8ff`),
    ...createConstraints('email')
  ) : query(collectionRef, ...createConstraints('name'));

  const usernameQuery = search? query(
    collectionRef,
    where('username', '>=', search),
    where('username', '<=', `${search}\uf8ff`),
    ...createConstraints('username')
  ) : query(collectionRef, ...createConstraints('name'));

  const nameResults = useFirestoreCollection(nameQuery, { idField: 'id' });
  const emailResults = useFirestoreCollection(emailQuery, { idField: 'id' });
  const usernameResults = useFirestoreCollection(usernameQuery, { idField: 'id' });

  const combinedResults = [
    nameResults,
    emailResults,
    usernameResults
  ];

  return combinedResults;
}
 
export default useFetchUsers;